module.exports = {
	"description": "The Icon component displays a graphic symbol representing an object or function.\n\nThe package provides a large number of prepackaged icon components as well\nas a generic icon component to which you can provide your own SVG.",
	"displayName": "Icon",
	"methods": [],
	"props": {
		"size": {
			"flowType": {
				"name": "union",
				"raw": "'small' | 'medium' | 'large' | string",
				"elements": [
					{
						"name": "literal",
						"value": "'small'"
					},
					{
						"name": "literal",
						"value": "'medium'"
					},
					{
						"name": "literal",
						"value": "'large'"
					},
					{
						"name": "string"
					}
				]
			},
			"required": false,
			"description": "Available sizes, including custom - e.g. '5em' or '20px'",
			"defaultValue": {
				"value": "'medium'",
				"computed": false
			}
		},
		"children": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": false,
			"description": "SVG content, required for the generic Icon component"
		},
		"color": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "Fill color, defaults to theme.color_gray_60"
		},
		"rtl": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Flip the icon horizontally when used with RTL languages"
		},
		"title": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "Alternative text"
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Icon/Icon.js
// module id = 1598
// module chunks = 0